export const MAPPING_INIT = 'MAPPING_INIT'
export const MAPPING_SAVE = 'MAPPING_SAVE'
export const MAPPING_UPDATE = 'MAPPING_UPDATE'
export const MAPPING_SELECT_TAB = 'MAPPING_SELECT_TAB'
